import DIApi from './_diApi';

class DefaultAccountAPI extends DIApi {
  controllerName = 'DefaultAccounts';
}

export default new DefaultAccountAPI();
